// BranchesViewPanel/index.js
import { connect } from 'react-redux';
import BranchesViewPanel from '../../components/BranchesViewPanel';

function mapStateToProps(state, ownProps) {
  return {
    currentBranchesRecord: state.branches.currentBranchesRecord,
    loggedInUser: state.users.user.item,
    currentBranch: state.branch.branch.item
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchesViewPanel);
